import { styled as styledMUI } from "@mui/material/styles";
import { CreateMUIStyled } from "@mui/system";
import { Theme } from "@mui/system/createTheme";

const styled: CreateMUIStyled<Theme> = styledMUI;
export default styled;
